import { download } from "../../../core/helpers/uri-util.js";
import InternationalizationService from "../../../core/services/InternationalizationService.js";

/**
 * TODO: write documentation
 */
export default class AbstractReportExporter {
	simpleLabel() {
		throw new Error("Subclass responsibility");
	}

	async download({ report, exportingSpec }) {
		const data = await this._makeReportData({
			report,
			exportingSpec,
		});

		const filename = this._filenameForReport(report);
		this._downloadData({ data, filename });
	}

	async bulkDownload({
		reports,
		exportingSpec,
		exportingName: _exportingName,
	}) {
		await Promise.all(
			reports.map((report) =>
				this.download({
					report,
					exportingSpec,
				}),
			),
		);
	}

	async _makeReportData({ report, exportingSpec }) {
		let result = undefined;

		const exportingVisitor = this._createExportingVisitor(exportingSpec);

		await this._prepareAssets({ exportingVisitor, report });

		InternationalizationService.instance().withoutHyphenation(() => {
			report.withCoALanguage(() => {
				result = exportingVisitor.visit(report);
			});
		});

		return result;
	}

	_filenameForReport(report) {
		return this._nameWithExtension(report.getTitleString());
	}

	_nameWithExtension(name) {
		return `${name}.${this._filenameExtension()}`;
	}

	_prepareAssets() {
		return Promise.resolve();
	}

	_downloadData({ data, filename }) {
		download({
			data,
			filename,
			mimetype: this._mimetype(),
		});
	}

	_mimetype() {
		throw new Error("Subclass responsibility");
	}

	_filenameExtension() {
		throw new Error("Subclass responsibility");
	}

	_createExportingVisitor(exportingVisitorSpec) {
		const Class = this._exportingVisitorClass();

		return new Class(exportingVisitorSpec);
	}

	_exportingVisitorClass() {
		throw new Error("Subclass responsibility");
	}
}
